import { render, staticRenderFns } from "./FlightListItem.vue?vue&type=template&id=67933a10&scoped=true&"
import script from "./FlightListItem.vue?vue&type=script&lang=js&"
export * from "./FlightListItem.vue?vue&type=script&lang=js&"
import style0 from "./FlightListItem.vue?vue&type=style&index=0&id=67933a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67933a10",
  null
  
)

export default component.exports